/**
 * Menu Icon
 * @author ryan bian
 */
<template>
  <span
    :class="{
      [$style.IconMenu__Wrapper]: true,
      [$style['IconMenu__Wrapper--active']]: active
    }"
    :style="{width: `${size}em`, height: `${size}em`}">
    <span :class="$style.IconMenu__Line" :style="{'background-color': color}" />
    <span :class="$style.IconMenu__Line" :style="{'background-color': color}" />
    <span :class="$style.IconMenu__Line" :style="{'background-color': color}" />
  </span>
</template>

<script>
export default {
  name: 'IconMenuComponent',
  props: {
    size: {
      type: Number,
      default: 1.5
    },
    color: {
      type: String,
      default: '#fff',
    }
  },
  data() {
    return {
      active: false,
    }
  }
}
</script>

<style lang="less" module>
.IconMenu {
  &__Wrapper {
    display: inline-flex;
    flex-direction: column;
    justify-content: space-around;
    &--active {
    }
    &:hover, &:focus {
      .IconMenu__Line {
        &:first-child {
          transform: translateY(-2px);
        }
        &:last-child {
          transform: translateY(2px);
        }
      }
    }
  }
  &__Line {
    flex: 0 0 1.2px;
    transition: all 0.2s ease;
  }
}
</style>


